import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { sec } from "@/lib/security";
import { getAdminAccessToken, getMusicProcessingApiBaseUrl } from "@/lib/adminApi";
import { performHardLogout } from "@/lib/authLogout";

// Slice #6 / UI-0 — SEPARATE RTK Query client for the music-PROCESSING API.
//
// Mirrors src/services/api.js exactly, but binds to the standalone
// music-processing API Gateway (getMusicProcessingApiBaseUrl), which has NO
// custom-domain mapping and is configured via
// REACT_APP_MUSIC_PROCESSING_API_BASE_URL. When that env var is unset the base
// URL is empty: queries fail fast with a controlled error the pages surface as
// a friendly "not configured" state instead of attempting an unreachable call.

const baseQueryWithRetry = async (args, api, extraOptions) => {
  const baseUrl = getMusicProcessingApiBaseUrl();

  if (!baseUrl) {
    return {
      error: {
        status: "CUSTOM_ERROR",
        error: "MUSIC_PROCESSING_API_NOT_CONFIGURED",
        data: {
          message: "Music processing is temporarily unavailable.",
        },
      },
    };
  }

  const result = await fetchBaseQuery({
    baseUrl,
    credentials: "omit",
    prepareHeaders: async (headers) => {
      try {
        const accessToken = await getAdminAccessToken();
        headers.set("Authorization", `Bearer ${accessToken}`);
      } catch (error) {
        if (
          error?.error === "login_required" ||
          error?.error === "missing_refresh_token" ||
          error?.message?.includes("Missing Refresh Token")
        ) {
          const auth0 = sec.getAuth0Client();
          const sdkLogout =
            auth0 && typeof auth0.logout === "function"
              ? auth0.logout.bind(auth0)
              : null;
          performHardLogout(sdkLogout);
        }
        throw error;
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  })(args, api, extraOptions);

  return result;
};

export const processingApi = createApi({
  reducerPath: "processingApi",
  baseQuery: baseQueryWithRetry,
  tagTypes: ["ProcessingJobs", "ApprovedArtifactVersions"],
  endpoints: () => ({}),
});
